/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { EventEmitter } from "eventemitter3";
//*
import { Network as StompNetwork } from "@/frameworks/libraries/network";
const Network = StompNetwork.instances["default"];
import { Topics } from "@/frameworks/core/commons";
/*/
import { Network } from "@/frameworks/libraries/network";
//*/
import { Properties } from "@/frameworks/libraries/properties";
import { Configure } from "@/frameworks/libraries/utilities";

// const SignalingClient = require('./SignalingClient');
// const EventEmitter = require('events').EventEmitter;

const LOGTAG = "#xms_network#";
// const signalingType = "pns"; // TODO: signalingType => this.type
// let isInstalled = false;
const XmsNetworkInstance = [];

export default class XmsNetwork extends EventEmitter {
	constructor(networkType) {
		super();

		this.networkType = networkType;
	}

	static on_message_received(message, topic) {
		for (const xmsNetwork of XmsNetwork.Instances) {
			Object.values(xmsNetwork)[0]?.onMessageReceived(topic, message);
		}
	}

	static get Instances() {
		return XmsNetworkInstance;
	}

	get isPrintable() {
		return Configure.useLogLevel > 5;
	}

	onMessageReceived = (topic, packet) => {
		const roomTopic = Topics.Public(`/${this.roomId}`);
		const userTopic = Topics.Public(`/${this.roomId}/${this.userId}`);
		if (topic === roomTopic || topic === userTopic) {
			this.isPrintable && console.debug(LOGTAG, `Message received.`, topic, packet.type, packet.payload);
			this.emit("message", packet.type, packet.payload);
		}
		// else   {
		//     console.debug('[XmsNetwork] different topic!!!');
		// }
	};

	init = async (roomId, userId) => {
		this.roomId = roomId;
		this.userId = userId;

		this.isPrintable && console.debug(LOGTAG, `init`, { roomId, userId });

		if (this.networkType === "xrm") {
			// this.messageReceivedCallback.bind(this);

			// check if the PNS is already connected.
			// if not, what to do?

			this.registerInstance();

			console.debug(
				LOGTAG,
				"Network.subscribe(",
				Topics.Public(`/${this.roomId}`),
				Topics.Public(`/${this.roomId}/${this.userId}`)
			);

			Network.subscribe([Topics.Public(`/${this.roomId}`), Topics.Public(`/${this.roomId}/${this.userId}`)]);
		} else {
			// await this.runSignalingClient();
		}
	};

	close = () => {
		this.isPrintable && console.debug(LOGTAG, `close`);

		if (this.networkType === "xrm") {
			console.debug(
				LOGTAG,
				"Network.unsubscribe(",
				Topics.Public(`/${this.roomId}`),
				Topics.Public(`/${this.roomId}/${this.userId}`)
			);

			Network.unsubscribe([Topics.Public(`/${this.roomId}`), Topics.Public(`/${this.roomId}/${this.userId}`)]);

			this.unregiseterInstance();
		}
	};

	registerInstance = () => {
		XmsNetworkInstance.push({ [`${this.roomId}/${this.userId}`]: this });
		this.isPrintable && console.debug(LOGTAG, "register network path:", `${this.roomId}/${this.userId}`);
	};

	unregiseterInstance = () => {
		if (XmsNetworkInstance.length === 1) {
			XmsNetworkInstance.shift();
		} else {
			const index = XmsNetworkInstance.findIndex(
				(value) => Object.keys(value)[0] === `${this.roomId}/${this.userId}`
			);
			XmsNetworkInstance.splice(index, 1);
		}
	};

	sendToXms = (msgType, message) => {
		if (this.networkType === "xrm") {
			const topic = `/${Properties.mediaServerHostName}`;
			this.isPrintable && console.debug(LOGTAG, `HostName`, Topics.ToPublic(topic));
			Network.publish(Topics.ToPublic(topic), msgType, message, { includeSelf: false });
		} else {
			// const topic = `/${this.config.xmsHostname}`;
			// this.signalingClient.send(JSON.stringify(message), topic);
		}
	};

	sendToUser = (msgType, message, userId) => {
		if (this.networkType === "xrm") {
			const topicToUser = `/${this.roomId}/${userId}`;
			Network.publish(Topics.ToPublic(topicToUser), msgType, message);
		} else {
			// const topicToUser = `/${this.roomId}/${userId}`;
			// this.signalingClient.send(JSON.stringify(message), topicToUser);
		}
	};

	sendToRoom = (msgType, message) => {
		if (this.networkType === "xrm") {
			const topicToRoom = `/${this.roomId}`;
			Network.publish(Topics.ToPublic(topicToRoom), msgType, message);
		} else {
			// const topicToRoom = `/${this.roomId}`;
			// this.signalingClient.send(JSON.stringify(message), topicToRoom);
		}
	};
}
